"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
exports.default = (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("path", { d: "M3 12H21M3 6H21M3 18H21", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    react_1.default.createElement("circle", { cx: "18", cy: "12", r: "2", fill: "currentColor" }),
    react_1.default.createElement("circle", { cx: "7", cy: "18", r: "2", fill: "currentColor" }),
    react_1.default.createElement("circle", { cx: "7", cy: "6", r: "2", fill: "currentColor" })));
